import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Stack,
  useToast,
  Button,
} from "@chakra-ui/react";
import EditModalforschoolmember from "./CreateMember/EditModalforschoolmember";
import Pay_member_library from "./CreateMember/Pay_member_library";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const SchoolList = () => {
  const toast = useToast();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [sdata, setSdata] = useState([]);
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [membershipFilter, setMembershipFilter] = useState("");
  const totalPages = Math.ceil(data.length / rowsPerPage);
  const schoolId = sessionStorage.getItem("school_id");
  const userId = sessionStorage.getItem("user_id");

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/admin/library/membership/list_member.php?school_id=${schoolId}`
      );
      const result = await response.json();
      console.log("response member", result);

      if (result.success) {
        setData(result.data);
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [schoolId]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleMembershipFilterChange = (e) => {
    setMembershipFilter(e.target.value);
    setCurrentPage(1);
  };

  const filteredData = data
    .filter(
      (row) =>
        row.member_name &&
        row.member_name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .filter((row) => {
      if (membershipFilter) {
        return row.member_type.toLowerCase() === membershipFilter.toLowerCase();
      }
      return true;
    });

  const currentData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const deleteMember = async (memberId) => {
    if (window.confirm("Are you sure you want to delete this member?")) {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/library/membership/delete_member.php`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              member_id: memberId,
              user_id: sessionStorage.getItem("user_id"),
            }),
          }
        );
        const result = await response.json();
        if (result.success) {
          toast({
            title: "Member deleted successfully.",
            description: "The member has been removed successfully.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          fetchData();
        } else {
          alert(result.message || "Failed to delete member");
        }
      } catch (err) {
        alert("Failed to delete member");
      }
    }
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        p={3}
        className="sb"
      >
        <Flex align="center" mb={{ base: 4, md: 0 }}>
          <Text mr={2}>Rows Per Page</Text>
          <Select
            width="120px"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </Select>
        </Flex>
        <Flex justifyContent="end">
          <Flex align="center" mb={{ base: 4, md: 0 }}>
            <Select
              width="180px"
              value={membershipFilter}
              onChange={handleMembershipFilterChange}
            >
              <option value="">All</option>
              <option value="Student">Student</option>
              <option value="Teacher">Teacher</option>
            </Select>
          </Flex>
          <Flex ml={1} align="center" mb={{ base: 4, md: 0 }}>
            <Input
              placeholder="Search by Name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Flex>
        </Flex>
      </Flex>

      {loading ? (
        <Text>Loading...</Text>
      ) : error ? (
        <Text color="red.500">{error}</Text>
      ) : (
        <Box overflowX="auto" maxWidth="100%">
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              "th, td": {
                textAlign: "center",
              },
            }}
          >
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Fees</Th>
                <Th>Membership Type</Th>
                <Th>Date</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.length > 0 ? (
                currentData.map((row) => (
                  <Tr key={row.id}>
                    <Td>{row.member_name}</Td>
                    <Td>{row.amount}</Td>
                    <Td>{row.member_type}</Td>
                    <Td>{new Date(row.created_at).toLocaleDateString()}</Td>
                    <Td textAlign="center">
                      <Stack
                        direction="row"
                        spacing={2}
                        justify="center" 
                        align="center"
                      >
                        <Button
                          colorScheme="blue"
                          size="sm"
                          alignSelf="flex-end"
                          // mt={2}
                          onClick={() => {
                            handleOpenModal();
                            setSdata(row);
                          }}
                        >
                          Pay
                        </Button>
                        <EditModalforschoolmember
                          memberId={row.id}
                          schoolId={schoolId}
                          userId={userId}
                        />
                        <Button
                          size="sm"
                          colorScheme="red"
                          onClick={() => deleteMember(row.id)}
                        >
                          Delete
                        </Button>
                      </Stack>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="5" textAlign="center">
                    No users available
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
          {isModalOpen && (
            <Pay_member_library
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              memberName={sdata.member_name}
              memberId={sdata.id}
              MemberLedgerId={
                sdata.member_type === "Student"
                  ? sdata.student_ledger_id
                  : sdata.teacher_ledger_id
              }
              totalAmount={sdata.amount}
            />
          )}
        </Box>
      )}

      <Flex justify="end" borderTopWidth="1px" className="sb2" p={3}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" mx={2}>
          {currentPage > 1 && (
            <>
              <Button onClick={() => handlePageChange(1)}>1</Button>
              {currentPage > 2 && <Text>...</Text>}
            </>
          )}
          <Button backgroundColor="teal" color="white">
            {currentPage}
          </Button>
          {currentPage < totalPages && (
            <>
              {currentPage < totalPages - 1 && <Text>...</Text>}
              <Button onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Button>
            </>
          )}
        </Stack>
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default SchoolList;
